module.exports = __webpack_public_path__ + "static/media/Ginny Weasley 1.d3413164.jpg";